import { createFileRoute } from "@tanstack/react-router";
import { DevicesIndexPage } from "@charphq/ui/components/device/devices-index-page";

export const Route = createFileRoute("/devices/")({
  component: AllDevicesComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    page: Number(search.page) || 1,
    pageSize: Number(search.pageSize) || 50,
    sortBy: (search.sortBy as string) || undefined,
    sortDirection: (search.sortDirection as "asc" | "desc") || undefined,
    globalFilter: (search.globalFilter as string) || undefined,
    columnFilters: (search.columnFilters as Record<string, unknown>) || undefined,
  }),
});

function AllDevicesComponent() {
  const search = Route.useSearch();

  return <DevicesIndexPage searchParams={search} />;
}
